import moment from "moment"
export default function times(timestamp) {
	// Debug
	/* const fixedDate = moment("2025-01-06")
	timestamp = fixedDate.unix()
	moment.now = () => +fixedDate */
	//
	let ret = {
		lastYear: moment.unix(moment.unix(timestamp).startOf("year").unix()).subtract(1, "year").unix(),
		thisYear: moment.unix(timestamp).startOf("year").unix(),
		endWeek: moment.unix(timestamp).endOf("isoweek").unix(),
		startWeek: moment.unix(moment.unix(timestamp).startOf("isoweek").unix()).unix(),
		priorEndWeek: moment.unix(timestamp).startOf("isoweek").subtract(1, "year").unix(),
		priorStartWeek: moment
			.unix(moment.unix(timestamp).startOf("isoweek").subtract(1, "year").unix())
			.subtract(7, "days")
			.unix(),
		currentPoint: moment.unix(timestamp).subtract(1, "year").unix(),
		year: new Date().getFullYear(),
		reportYear: moment.unix(timestamp).year(),
		dayOfMonth: moment.unix(timestamp).date(),
		curMonth: moment.unix(timestamp).month() + 1,
		curWeek: moment.unix(timestamp).isoWeek(),
		lastWeekNumber: moment.unix(timestamp).subtract(7, "days").week(),
		curDay: parseInt(moment.unix(timestamp).format("D")),
		lastWeek: moment.unix(timestamp).isoWeek() - 1,
		fiveYears: moment.unix(timestamp).startOf("year").subtract(5, "years").unix(),
		dayLastYear: moment.unix(timestamp).subtract(1, "year").unix(),
		dayLastYearPlusWeek: moment.unix(timestamp).subtract(1, "year").add(1, 'week').unix(),
		endWeekYear: moment.unix(timestamp).endOf("isoweek").year(),
		endWeekStartYear: moment.unix(timestamp).endOf("isoweek").startOf("year").unix(),
	}
	return ret
}
